import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ContentOverviewPage = lazy(() => import('~/features/content/pages/content-overview-page'));

/** Content home at `/content/overview` — what is happening and what needs attention. */
export const Route = createFileRoute('/_authenticated/_tenant/content/overview')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ContentOverviewPage />
    </Suspense>
  ),
});
